<template>
  <swiper
    :effect="'coverflow'"
    :grabCursor="true"
    :centeredSlides="true"
    :centeredSlidesBounds="true"
    :slidesPerView="'auto'"
    :coverflowEffect="{
      rotate: 0,
      stretch: 0,
      depth: 200,
      modifier: 2,
      slideShadows: false,
    }"
    :pagination="true"
    :modules="modules"
    class="mySwiper"
  >
    <swiper-slide class="bg-white rounded-lg blur-[2px] opacity-30">
      <div
        class="bg-white h-full w-full flex justify-around items-center rounded-lg flex-col pt-10"
      >
        <p class="text-[18px] font-semibold">Campaign Name</p>
        <div class="w-full">
          <div
            class="bg-[#EEEEEE] bg-opacity-40 w-full p-2 py-4 flex justify-between px-8"
          >
            <p class="text-[22px] font-extrabold">Campaign Status</p>
            <div class="flex items-center gap-1">
              <svg
                id="svgexport-7_23_"
                data-name="svgexport-7 (23)"
                xmlns="http://www.w3.org/2000/svg"
                width="20.473"
                height="20.473"
                viewBox="0 0 20.473 20.473"
              >
                <g id="Group_17232" data-name="Group 17232">
                  <path
                    id="Path_26699"
                    data-name="Path 26699"
                    d="M10.237,0A10.237,10.237,0,1,0,20.473,10.237,10.246,10.246,0,0,0,10.237,0Z"
                    fill="#369da3"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_26700"
                    data-name="Path 26700"
                    d="M138.7,165.184a.71.71,0,0,1,0,1l-6.632,6.632a.7.7,0,0,1-1,0l-3.316-3.316a.707.707,0,0,1,1-1l2.816,2.816,6.132-6.132A.7.7,0,0,1,138.7,165.184Z"
                    transform="translate(-122.993 -158.763)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                </g>
              </svg>
              <p class="text-[22px] font-bold">Active</p>
            </div>
          </div>
        </div>
        <div class="w-full px-8">
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Campaign Type:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">Awareness</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Ad Loop:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">8k ~ 14k</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Impressions:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1.000.000</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">
              Target Locations:
            </p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">2 Location(s)</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Start Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1/1/2001</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">End Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1/1/2001</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Budget:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">20,000 EGP</p>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide
      class="rounded-lg bg-black"
      v-for="campaign in campaignsData"
      :key="campaign"
    >
      <div
        class="bg-white h-full w-full flex justify-around items-center rounded-lg flex-col pt-10"
      >
        <p class="text-[18px] font-semibold capitalize">
          {{ campaign.campaign_title }}
        </p>
        <div class="w-full">
          <div
            class="bg-[#EEEEEE] bg-opacity-40 w-full p-2 py-4 flex justify-between px-8"
          >
            <p class="text-[22px] font-extrabold">Campaign Status</p>
            <div class="flex items-center gap-1">
              <!--   <img src="../../assets/SVGs/Pending.svg" v-if="
                  !campaign.is_approved &&
                    !campaign.is_expired ||
                  (campaign.is_approved &&
                    !campaign.is_active && !campaign.is_expired)
                ">-->
              <svg
                v-if="
                  (!campaign.is_approved && !campaign.is_expired) ||
                  (campaign.is_approved &&
                    !campaign.is_active &&
                    !campaign.is_expired)
                "
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
              >
                <g id="Waiting" transform="translate(-524 -272)">
                  <circle
                    id="Ellipse_1224"
                    data-name="Ellipse 1224"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(524 272)"
                    fill="none"
                  />
                  <g
                    id="Group_16555"
                    data-name="Group 16555"
                    transform="translate(529 277)"
                  >
                    <circle
                      id="Ellipse_1222"
                      data-name="Ellipse 1222"
                      cx="8"
                      cy="8"
                      r="8"
                      fill="#ffbe00"
                    />
                    <path
                      id="time-oclock"
                      d="M5.567,0a5.567,5.567,0,1,0,5.567,5.567A5.567,5.567,0,0,0,5.567,0Zm0,10.206a4.639,4.639,0,1,1,4.639-4.639A4.639,4.639,0,0,1,5.567,10.206Zm.928-4.639a.928.928,0,1,1-1.392-.8V3.247a.464.464,0,1,1,.928,0v1.52a.925.925,0,0,1,.464.8Z"
                      transform="translate(2.433 2.433)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
              <!-- <img src="../../assets/SVGs/Expired.svg" v-if="campaign.is_expired "> -->
              <svg
                v-if="campaign.is_expired"
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
              >
                <g
                  id="Expired_at_"
                  data-name="Expired at "
                  transform="translate(-124 -684)"
                >
                  <circle
                    id="Ellipse_1224"
                    data-name="Ellipse 1224"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(124 684)"
                    fill="none"
                  />
                  <g id="cross-circle" transform="translate(129.6 689.6)">
                    <path
                      id="Path_25685"
                      data-name="Path 25685"
                      d="M7.4,0a7.4,7.4,0,1,0,7.4,7.4A7.4,7.4,0,0,0,7.4,0ZM9.867,9a.617.617,0,1,1-.835.907Q9.013,9.885,9,9.867L7.4,8.272,5.805,9.867a.617.617,0,0,1-.872-.872L6.528,7.4,4.933,5.805a.617.617,0,0,1,.872-.872L7.4,6.528,9,4.933a.617.617,0,0,1,.907.835q-.017.019-.036.036L8.272,7.4Z"
                      transform="translate(0)"
                      fill="#bf3939"
                    />
                  </g>
                </g>
              </svg>
              <!-- <img src="../../assets/SVGs/Active.svg" v-if="campaign.is_active"> -->
              <svg
                v-if="campaign.is_active"
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
              >
                <g id="Active" transform="translate(-97 -295)">
                  <circle
                    id="Ellipse_1224"
                    data-name="Ellipse 1224"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(97 295)"
                    fill="none"
                  />
                  <g
                    id="active_icon"
                    data-name="active icon"
                    transform="translate(102 299.78)"
                  >
                    <circle
                      id="Ellipse_1206"
                      data-name="Ellipse 1206"
                      cx="8"
                      cy="8"
                      r="8"
                      transform="translate(0 0.22)"
                      fill="#369DA3"
                    />
                    <path
                      id="shield-check_1_"
                      data-name="shield-check (1)"
                      d="M14.216,8.532l-3.4,3.4a1.489,1.489,0,0,1-1.061.44H9.732a1.488,1.488,0,0,1-1.069-.477L6.829,9.983a.8.8,0,1,1,1.146-1.1l1.784,1.86,3.33-3.339A.8.8,0,1,1,14.213,8.53Z"
                      transform="translate(-2.377 -1.685)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </svg>
              <p
                class="md:text-[20px] text-[12px] font-semibold"
                :class="[
                  campaign.is_active ? 'text-black' : '',
                  campaign.is_expired ? 'text-red-600' : '',
                  !campaign.is_approved && !campaign.is_expired
                    ? 'text-secondary'
                    : '',
                  campaign.is_approved ? 'text-black' : '',
                ]"
              >
                {{ campaign.is_active ? "Active " : "" }}
                {{
                  !campaign.is_approved && !campaign.is_expired
                    ? "Pending Approval"
                    : ""
                }}
                {{
                  campaign.is_approved &&
                  !campaign.is_active &&
                  !campaign.is_expired
                    ? " Approved"
                    : ""
                }}
                {{ campaign.is_expired ? "Expired " : "" }}
                <br />
                <!-- {{ moment(campaign.starts_att, "YYYY-MM-DD").format("DD.MM.YYYY") }} -->
              </p>
            </div>
          </div>
        </div>
        <div class="w-full px-8">
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Campaign Type:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">
                {{
                  campaign.advertising_goal == null
                    ? "Awareness"
                    : campaign.advertising_goal
                }}
              </p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Ad Loop:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">{{ ad_loops }}</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Impressions:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">{{ impressions }}</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">
              Target Location(s):
            </p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">
                {{ campaign.zone_count }} Location(s)
              </p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Start Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">{{ campaign.starts_at }}</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">End Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">{{ campaign.ends_at }}</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Budget:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">
                {{ campaign.budget.toLocaleString() }} {{ currency }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="bg-white rounded-lg blur-[2px] opacity-30">
      <div
        class="bg-white h-full w-full flex justify-around items-center rounded-lg flex-col pt-10"
      >
        <p class="text-[18px] font-semibold">Campaign Name</p>
        <div class="w-full">
          <div
            class="bg-[#EEEEEE] bg-opacity-40 w-full p-2 py-4 flex justify-between px-8"
          >
            <p class="text-[22px] font-extrabold">Campaign Status</p>
            <div class="flex items-center gap-1">
              <svg
                id="svgexport-7_23_"
                data-name="svgexport-7 (23)"
                xmlns="http://www.w3.org/2000/svg"
                width="20.473"
                height="20.473"
                viewBox="0 0 20.473 20.473"
              >
                <g id="Group_17232" data-name="Group 17232">
                  <path
                    id="Path_26699"
                    data-name="Path 26699"
                    d="M10.237,0A10.237,10.237,0,1,0,20.473,10.237,10.246,10.246,0,0,0,10.237,0Z"
                    fill="#369da3"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_26700"
                    data-name="Path 26700"
                    d="M138.7,165.184a.71.71,0,0,1,0,1l-6.632,6.632a.7.7,0,0,1-1,0l-3.316-3.316a.707.707,0,0,1,1-1l2.816,2.816,6.132-6.132A.7.7,0,0,1,138.7,165.184Z"
                    transform="translate(-122.993 -158.763)"
                    fill="#fff"
                    fill-rule="evenodd"
                  />
                </g>
              </svg>
              <p class="text-[22px] font-bold">Active</p>
            </div>
          </div>
        </div>
        <div class="w-full px-8">
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Campaign Type:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">Awareness</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Ad Loop:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">8k ~ 14k</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Impressions:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1.000.000</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">
              Target Locations :
            </p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">2 Location(s)</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Start Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1/1/2001</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">End Date:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">1/1/2001</p>
            </div>
          </div>
          <hr class="h-1 w-[100%]" />
          <div class="w-full p-2 flex justify-between">
            <p class="text-[14px] font-medium text-[#AEAEAE]">Budget:</p>
            <div class="flex items-center gap-1">
              <p class="text-[14px] font-semibold">20,000 EGP</p>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/effect-coverflow";
// import "swiper/css/pagination";

// import required modules
import { EffectCoverflow } from "swiper";

export default {
  props: ["campaignsData"],
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [EffectCoverflow],
      currency: null,
    };
  },
  computed: {
    impressions() {
      if (!this.campaignsData[0].budget) {
        return "-";
      }
      // let cost = 0.09;
      // let val = this.campaignsData[0].budget / cost;
      // let min = Math.round((val * 0.75) / 1e3);
      // let max = Math.round((val * 1.25) / 1e3);

      // return `${min}k ~ ${max}k`;
      if (this.$store.state.auth.country_code === "EG") {
        let cost = 0.09;
        let val = this.campaignsData[0].budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      } else if (this.$store.state.auth.country_code === "SA") {
        let cost = 0.01125;
        let val = this.campaignsData[0].budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      }
    },
    ad_loops() {
      if (!this.campaignsData[0].budget) {
        return "-";
      }
      // let cost = 0.65;
      // let val = this.campaignsData[0].budget / cost;
      // let min = Math.round((val * 0.75) / 1e3);
      // let max = Math.round((val * 1.25) / 1e3);

      // return `${min}k ~ ${max}k`;
      if (this.$store.state.auth.country_code === "EG") {
        let cost = 0.65;
        let val = this.campaignsData[0].budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      } else if (this.$store.state.auth.country_code === "SA") {
        let cost = 0.08125;
        let val = this.campaignsData[0].budget / cost;
        let min = Math.round((val * 0.75) / 1e3);
        let max = Math.round((val * 1.25) / 1e3);
        return `${min}k ~ ${max}k`;
      }
    },
  },

  mounted() {
    this.currency = this.getCenterCoordinates();
  },

  methods: {
    getCenterCoordinates() {
      const country = this.$store.state.auth.country_code;

      let currency = this.currency;

      if (country === "EG") {
        currency = "EGP"; // cairo currency
      } else if (country === "SA") {
        currency = "SAR"; //riydh currency
      }

      return currency;
    },
  },
};
</script>

<style>
.swiper {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 500px;
  height: 500px;
}
.swiper-slide.swiper-slide-active {
  background-color: white;
}
/* .swiper-slide img {
    display: block;
    width: 100%;
} */
</style>
